var _g, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.318,
    y: 95.157,
    style: {
      fill: "#E0E0E0"
    },
    width: 117.624,
    height: 173.803
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.647,
    y: 95.157,
    style: {
      fill: "#F0F0F0"
    },
    width: 117.624,
    height: 173.803
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.371,
    y: 187.04,
    style: {
      fill: "#EBEBEB"
    },
    width: 105.95,
    height: 71.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.371,
    y: 102.22,
    style: {
      fill: "#FFFFFF"
    },
    width: 105.95,
    height: 84.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.594,
    y: 102.224,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.729,
    height: 156.555
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.625,
    y: 137.457,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -90.4165 287.4495)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.784,
    height: 102.951
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.371,
    y: 180.69,
    style: {
      fill: "#F0F0F0"
    },
    width: 107.95,
    height: 6.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M438.17,383.534H294.81c-10.863,0-19.669-8.806-19.669-19.669v-42.669 c0-10.863,8.806-19.669,19.669-19.669H438.17c10.863,0,19.669,8.806,19.669,19.669v42.669 C457.84,374.728,449.033,383.534,438.17,383.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M428.543,384.14H285.183c-10.863,0-19.669-8.806-19.669-19.669v-42.669 c0-10.863,8.806-19.669,19.669-19.669h143.361c10.863,0,19.669,8.806,19.669,19.669v42.669 C448.213,375.334,439.406,384.14,428.543,384.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M439.838,340.461H274.962v-16.857c0-7.587,6.151-13.738,13.738-13.738h137.4 c7.587,0,13.738,6.151,13.738,13.738V340.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M426.1,375.196H288.7c-7.587,0-13.738-6.151-13.738-13.738v-16.857h164.876v16.857 C439.838,369.045,433.687,375.196,426.1,375.196z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.304,
    y: 315.788,
    style: {
      fill: "#E6E6E6"
    },
    width: 30.187,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.572,
    y: 315.788,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.732,
    height: 24.875
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M363.981,333.969c0,1.404-1.138,2.543-2.543,2.543c-1.404,0-2.543-1.138-2.543-2.543 s1.138-2.543,2.543-2.543C362.842,331.426,363.981,332.565,363.981,333.969z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.731,
    y: 311.952,
    style: {
      fill: "#E6E6E6"
    },
    width: 22.677,
    height: 28.711
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.184,
    y: 311.952,
    style: {
      fill: "#F5F5F5"
    },
    width: 6.556,
    height: 28.711
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 377.462,
    cy: 316.124,
    r: 2.247
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 377.462,
    cy: 316.124,
    r: 2.247
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.412,
    y: 315.788,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.119,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.045,
    y: 315.788,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.367,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.06,
    y: 319.997,
    style: {
      fill: "#E6E6E6"
    },
    width: 25.077,
    height: 20.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.639,
    y: 319.997,
    style: {
      fill: "#F5F5F5"
    },
    width: 6.421,
    height: 20.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.874,
    y: 316.811,
    style: {
      fill: "#E6E6E6"
    },
    width: 18.839,
    height: 23.852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.436,
    y: 316.811,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.447,
    height: 23.852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.427,
    y: 319.997,
    style: {
      fill: "#E6E6E6"
    },
    width: 18.299,
    height: 20.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.792,
    y: 319.997,
    style: {
      fill: "#F0F0F0"
    },
    width: 3.625,
    height: 20.666
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.964,
    y: 349.379,
    style: {
      fill: "#E6E6E6"
    },
    width: 23.367,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.978,
    y: 349.379,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.985,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.905,
    y: 345.543,
    style: {
      fill: "#E6E6E6"
    },
    width: 17.553,
    height: 28.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.837,
    y: 345.543,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.075,
    height: 28.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.682,
    y: 349.379,
    style: {
      fill: "#E6E6E6"
    },
    width: 23.367,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.697,
    y: 349.379,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.985,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.623,
    y: 345.543,
    style: {
      fill: "#E6E6E6"
    },
    width: 17.553,
    height: 28.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.556,
    y: 345.543,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.075,
    height: 28.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.077,
    y: 349.379,
    style: {
      fill: "#EBEBEB"
    },
    width: 14.8,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.696,
    y: 349.379,
    style: {
      fill: "#F5F5F5"
    },
    width: 3.381,
    height: 24.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.189,
    y: 353.588,
    style: {
      fill: "#E6E6E6"
    },
    width: 19.412,
    height: 20.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.219,
    y: 353.588,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.97,
    height: 20.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.108,
    y: 350.401,
    style: {
      fill: "#E6E6E6"
    },
    width: 14.583,
    height: 23.852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.899,
    y: 350.401,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.217,
    height: 23.852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.407,
    y: 353.588,
    style: {
      fill: "#E6E6E6"
    },
    width: 14.165,
    height: 20.666
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.593,
    y: 353.588,
    style: {
      fill: "#F0F0F0"
    },
    width: 2.806,
    height: 20.666
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M340.447,277.683c-0.498-0.98-1.633-1.547-2.666-1.331c-1.033,0.216-1.878,1.198-1.985,2.304 c-0.73-0.546-1.775-0.574-2.53-0.067c-0.755,0.507-1.175,1.518-1.018,2.449c-0.823-0.665-2.173-0.39-2.704,0.55 c-0.531,0.941-0.119,2.327,0.826,2.777c-0.643,0.046-1.195,0.688-1.178,1.368c0.017,0.681,0.6,1.29,1.244,1.301 c-0.651,0.015-1.251,0.588-1.329,1.272c-0.079,0.684,0.373,1.392,1.002,1.572c-0.662,0.294-0.829,1.381-0.29,1.882 c0.539,0.5,1.538,0.183,1.727-0.548c0.101,0.211,0.413,0.261,0.568,0.09c0.155-0.171,0.095-0.498-0.109-0.596 c0.298,0.42,1.059,0.225,1.142-0.292c-0.224,1.199,1.206,2.326,2.229,1.758c-0.295,0.501,0.122,1.199,0.66,1.355 c0.538,0.156,1.106-0.064,1.612-0.314c0.506-0.25,1.022-0.541,1.581-0.533c0.489,0.007,0.945,0.243,1.414,0.394 c1.488,0.477,3.208,0.023,4.309-1.138c0.773,1.038,2.606,0.759,3.07-0.468c0.119,0.589,0.64,1.059,1.208,1.092 c0.569,0.034,1.135-0.373,1.316-0.944c0.012,0.262,0.023,0.525,0.035,0.787c1.072,0.254,2.131-1.13,1.671-2.186 c0.765,0.014,1.49-0.647,1.588-1.449c0.099-0.802-0.441-1.637-1.185-1.831c1.261-0.354,2.224-1.662,2.238-3.042 c0.014-1.379-0.922-2.709-2.176-3.091c-0.494-0.151-1.075-0.147-1.469,0.201c-0.395,0.348-0.447,1.115-0.006,1.395 c0.379-1.237-0.183-2.719-1.266-3.336c-1.083-0.617-2.563-0.3-3.332,0.715c0.375-0.526,0.382-1.311,0.017-1.844 c-0.365-0.533-1.073-0.771-1.663-0.559c-0.147-0.849-0.993-1.491-1.801-1.366s-1.445,0.997-1.355,1.855 c-0.093-0.717-1.208-0.927-1.529-0.288C339.86,277.45,340.447,277.683,340.447,277.683z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M340.747,285.666c-0.331-0.23-0.749-0.354-1.143-0.275c-0.395,0.079-0.752,0.384-0.833,0.779 c-0.081,0.395,0.164,0.846,0.556,0.941c0.476,0.115,0.953-0.277,1.438-0.209c0.173,0.025,0.333,0.107,0.502,0.152 c0.697,0.186,1.388-0.269,1.967-0.7c0.204-0.152,0.412-0.308,0.548-0.523c0.136-0.214,0.186-0.502,0.058-0.722 c-0.178-0.305-0.6-0.35-0.952-0.31c-0.705,0.081-1.385,0.365-1.938,0.81c0.018-0.11,0.036-0.221,0.054-0.331 L340.747,285.666z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M350.88,285.067c-0.189-0.132-0.384-0.267-0.609-0.32c-0.225-0.053-0.489-0.005-0.631,0.177 c-0.195,0.249-0.071,0.639,0.176,0.837c0.247,0.197,0.576,0.252,0.888,0.301c0.321,0.05,0.726,0.061,0.885-0.222 c0.116-0.207,0.023-0.48-0.15-0.642c-0.173-0.162-0.406-0.239-0.632-0.312L350.88,285.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M334.873,279.797c-0.645,0.27-1.144,0.867-1.294,1.549c-0.045,0.206-0.039,0.465,0.141,0.575 c0.128,0.078,0.292,0.046,0.437,0.011c0.618-0.147,1.237-0.294,1.855-0.44c-0.296,0.114-0.599,0.232-0.836,0.444 c-0.236,0.211-0.395,0.54-0.318,0.848c0.091,0.361,0.487,0.583,0.859,0.578c0.373-0.005,0.719-0.19,1.022-0.408 c0.323-0.232,0.639-0.553,0.645-0.95c0.006-0.397-0.495-0.766-0.8-0.511c0.707-0.192,1.382-0.5,1.991-0.907 c0.22-0.147,0.437-0.313,0.576-0.539c0.139-0.226,0.186-0.524,0.059-0.756c-0.634-1.152-1.435,0.538-1.825,0.688 C336.646,280.264,335.812,279.405,334.873,279.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M331.99,284.714c-0.065,0.225-0.021,0.497,0.163,0.643c0.183,0.146,0.508,0.097,0.592-0.122 c-0.414,0.129-0.856,0.278-1.114,0.627c-0.258,0.349-0.194,0.958,0.218,1.093c0.257,0.084,0.532-0.042,0.77-0.172 c0.672-0.367,1.314-0.79,1.916-1.263c-0.184,0.425,0.259,0.907,0.72,0.947c0.461,0.039,0.893-0.21,1.288-0.45 c0.485-0.295,1.042-0.745,0.914-1.299c-0.111-0.482-0.727-0.695-1.201-0.554c-0.474,0.141-0.83,0.523-1.162,0.89 c0.26-0.379-0.11-0.942-0.565-1.003c-0.443-0.06-0.884,0.21-1.16,0.536c0.516-0.283,0.631-1.021-0.06-1.106 C332.861,283.424,332.098,284.339,331.99,284.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M346.146,283.058c-0.39-0.146-0.878,0.108-0.983,0.51c-0.105,0.402,0.197,0.862,0.608,0.925 c-0.302,0.026-0.592,0.177-0.786,0.41c-0.108,0.129-0.19,0.296-0.165,0.463c0.036,0.25,0.302,0.414,0.554,0.423 c0.252,0.009,0.492-0.098,0.722-0.202c-0.249,0.023-0.513,0.052-0.71,0.206c-0.198,0.153-0.283,0.478-0.106,0.654 c0.148,0.147,0.393,0.123,0.594,0.066c0.452-0.127,0.873-0.363,1.215-0.684c0.257,0.285,0.639,0.491,1.018,0.429 c0.379-0.062,0.701-0.465,0.582-0.831c-0.085-0.261-0.357-0.425-0.629-0.458c-0.272-0.033-0.545,0.042-0.805,0.126 c0.267-0.189,0.549-0.401,0.647-0.713c0.098-0.312-0.113-0.731-0.44-0.706c-0.367,0.029-0.554,0.528-0.844,0.708 C346.26,284.048,346.93,283.35,346.146,283.058z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M339.536,281.532c-0.417,0.283-0.562,0.84-0.533,1.343c0.032,0.555,0.285,1.149,0.794,1.372 c0.671,0.293,1.508-0.265,1.631-0.986c0.123-0.721-0.35-1.455-1-1.793C340.43,281.468,339.954,281.25,339.536,281.532z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M344.218,280.933c0.058,0.05,0.115,0.099,0.173,0.149c-0.284-0.36-0.885-0.407-1.222-0.096 c-0.338,0.311-0.34,0.913-0.004,1.226c0.335,0.313,0.936,0.27,1.223-0.088c0.484,0.225,1.122,0.137,1.463-0.274 c0.34-0.411,0.263-1.127-0.201-1.391c-0.464-0.263-1.17,0.132-1.121,0.663c-0.067-0.075-0.134-0.15-0.201-0.224 L344.218,280.933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M349.386,281.767c-0.331,0.326-0.676,0.675-0.798,1.124c-0.122,0.449,0.079,1.02,0.53,1.135 c0.448,0.114,0.873-0.255,1.128-0.641c0.231-0.348,0.407-0.781,0.274-1.176c-0.133-0.396-0.702-0.63-0.987-0.325 L349.386,281.767z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M341.939,279.055c-0.169-0.376-0.704-0.508-1.054-0.29c-0.35,0.218-0.479,0.709-0.326,1.092 c0.153,0.383,0.546,0.643,0.957,0.688c0.508,0.056,1.108-0.355,0.994-0.853c0.219,0.289,0.612,0.403,0.973,0.368 c0.361-0.035,0.695-0.199,1.01-0.38c0.426-0.245,0.881-0.625,0.836-1.115c-0.036-0.39-0.414-0.691-0.804-0.727 c-0.39-0.036-0.775,0.145-1.073,0.4c-0.234,0.2-0.429,0.447-0.682,0.622c-0.253,0.175-0.598,0.269-0.869,0.123 L341.939,279.055z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "348.299,301.795 335.493,301.795 334.239,288.888 349.553,288.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "350.545,289.555 333.121,289.555 332.807,287.838 350.858,287.838  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "335.001,340.635 320.301,340.635 324.907,325.794 325.581,323.625 328.906,323.625  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "325.581,323.625 324.907,325.794 320.301,340.635 306.712,340.433 302.343,325.794  301.669,323.625  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "325.581,323.625 324.907,325.794 320.301,340.635 292.39,340.22 298.337,323.625  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "325.581,323.625 324.907,325.794 297.566,325.794 298.337,323.625  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M301.769,332.844h-6.129l2.138-6.037l5.862,0.065L301.769,332.844z M296.348,332.344h5.054 l1.56-4.979l-4.832-0.054L296.348,332.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M308.625,332.844h-6.129l2.138-6.037l5.862,0.065L308.625,332.844z M303.204,332.344h5.054 l1.559-4.979l-4.831-0.054L303.204,332.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M315.482,332.844h-6.129l2.139-6.037l5.862,0.065L315.482,332.844z M310.061,332.344h5.054 l1.56-4.979l-4.832-0.054L310.061,332.344z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M322.339,332.844h-6.128l2.138-6.037l5.861,0.065L322.339,332.844z M316.918,332.344h5.054 l1.56-4.979l-4.831-0.054L316.918,332.344z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M299.63,339.25h-6.129l2.138-6.037l5.862,0.065L299.63,339.25z M294.209,338.75h5.054 l1.56-4.98l-4.832-0.054L294.209,338.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M306.487,339.25h-6.128l2.138-6.037l5.861,0.065L306.487,339.25z M301.066,338.75h5.054 l1.56-4.98l-4.831-0.054L301.066,338.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M313.344,339.25h-6.129l2.139-6.037l5.862,0.065L313.344,339.25z M307.922,338.75h5.054 l1.56-4.98l-4.832-0.054L307.922,338.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M320.2,339.25h-6.129l2.138-6.037l5.861,0.065L320.2,339.25z M314.779,338.75h5.054l1.56-4.98 l-4.831-0.054L314.779,338.75z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M413.211,293.789c0,3.151,0.495,5.189,1.327,6.496c0.626,0.984,1.751,1.537,2.917,1.537h4.562 c1.166,0,2.291-0.553,2.917-1.537c0.833-1.308,1.327-3.345,1.327-6.496c0-4.57-1.993-8.229-2.643-11.151 c-0.234-1.052,0.546-4.276,0.546-4.276h-8.856c0,0,0.78,3.224,0.546,4.276C415.203,285.56,413.211,289.219,413.211,293.789z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M422.692,256.297c0,0-1.493,0.373-2.362,1.531c-0.869,1.158,0.632,3.885,0.632,3.885 s1.419,1.448,3.183,1.017c1.764-0.431,1.764-0.431,1.764-0.431s-1.866-5.345-3.205-5.648L422.692,256.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M429.654,257.575c-0.234,2.324-2.197,4.939-4.271,4.73c-2.075-0.209-3.476-3.164-3.242-5.488 c0.234-2.324,1.924-2.235,3.999-2.025C428.215,255.001,429.888,255.251,429.654,257.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M423.803,255.771c0,0,1.325,1.538,4.676,1.42 C428.479,257.191,422.77,259.613,423.803,255.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M425.264,255.577c0,0,1.858,0.027,1.742,0.783c0,0,1.542,0.204,1.452-0.475 C428.368,255.206,425.264,255.577,425.264,255.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M423.803,255.771c0,0,1.325,1.538,4.676,1.42 C428.479,257.191,422.77,259.613,423.803,255.771z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M425.264,255.577c0,0,1.858,0.027,1.742,0.783c0,0,1.542,0.204,1.452-0.475 C428.368,255.206,425.264,255.577,425.264,255.577z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M421.82,262.38c0.45,1.176,1.672,1.967,2.928,2.053c1.256,0.086,2.507-0.473,3.407-1.352 c0.9-0.88,1.472-2.055,1.784-3.275c0.081-0.316,0.257-1.111-0.141-1.313c-0.365-0.186-0.706,0.309-0.932,0.527 c-0.652,0.627-1.326,1.203-2.095,1.684c-0.746,0.466-1.546,0.846-2.378,1.129C424.161,261.911,421.9,262.588,421.82,262.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M431.441,259.471c0.211,1-0.143,2.1-0.897,2.789c-0.495,0.453-1.128,0.723-1.757,0.957 c-0.438,0.163-0.986,0.292-1.324-0.03c-0.365-0.347-0.212-0.951-0.024-1.418c0.288-0.72,0.596-1.432,0.923-2.136 c0.268-0.577,0.553-1.574,1.006-2.021c0.426-0.421,0.845-0.045,1.283,0.402C431.041,258.413,431.325,258.922,431.441,259.471 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M422.581,261.212c-0.782-0.183-1.427-0.857-1.574-1.647c-0.109-0.584,0.156-1.962,0.893-2.004 C421.98,258.846,422.039,260.009,422.581,261.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.212,261.62c0.785-0.072,1.519-0.563,1.886-1.26c0.202-0.385,0.439-2.505-0.348-1.745 c-0.257,0.249-0.393,1.173-0.568,1.524C428.918,260.668,428.592,261.167,428.212,261.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M425.118,262.371c0.483,0.598,1.399,0.796,2.086,0.451c-0.155,0.389-1.492,0.486-1.909,0.528 c-1.085,0.108-1.538-0.446-2.457-1.052C422.838,262.298,424.373,262.837,425.118,262.371z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "418.512,299.315 421.069,273.488 424.455,264.325 425.042,264.542 421.671,273.664  419,300.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M421.65,273.435l-0.559,0.282c-0.368-0.729-0.651-1.643-0.979-2.701 c-0.507-1.636-1.081-3.49-2.155-5.238l0.533-0.328c1.115,1.815,1.702,3.709,2.22,5.38 C421.029,271.862,421.305,272.753,421.65,273.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M423.026,270.049c0.869-0.061,1.712-0.449,2.324-1.069c0.696-0.704,1.071-1.655,1.428-2.578 c-1.135,0.118-2.19-0.622-3.329-0.705c-0.907-0.066-1.836,0.319-2.432,1.007c-0.771,0.891-1.222,1.982-0.795,2.538 C420.575,269.7,421.863,270.131,423.026,270.049z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M413.884,267.253c0.839-0.697,2.635-0.978,3.653-0.587c1.018,0.391,1.78,1.287,1.994,2.221 c-0.405,0.616-1.223,0.853-1.956,0.768c-0.733-0.085-1.405-0.434-2.058-0.776c-0.653-0.343-1.325-0.692-2.058-0.777 L413.884,267.253z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M419.52,267.744c-1.482,0.165-2.81,0.461-4.157-1.225c-0.903-1.13-0.614-2.838-0.548-4.189 c1.286,0.282,4.202,1.701,4.849,2.049s1.198,0.913,1.304,1.582c0.107,0.669-0.347,1.413-1.077,1.536 C419.866,267.46,419.52,267.744,419.52,267.744z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M415.276,287.835c-0.595,1.681-1.16,3.51-0.966,5.297c0.037,0.34,0.142,0.728,0.387,0.789 c0.228,0.056,0.454-0.224,0.535-0.533c0.081-0.309,0.06-0.639,0.059-0.961c-0.007-2.77,1.501-5.104,1.787-7.806 c0.081-0.768-0.117-3.193-0.567-1.411C416.11,284.798,415.825,286.284,415.276,287.835z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M205.77,342.861c0,0,2.907-32.208-9.892-47.916c-12.8-15.708,9.993-1.407,14.03,14.258 c0,0,0.756-28.973-12.017-47.749s8.998-4.724,12.794,15.754c0,0,0.723-25.854-5.658-39.562c-6.382-13.708,3.137-5.548,7.345,3.02 c4.208,8.568,2.115,31.297,2.115,31.297s4.474-42.101,12.962-39.82c8.488,2.281-9.151,31.644-10.563,45.98 c0,0,7.719-19.996,15.413-16.958c7.693,3.038-10.71,7.237-16.393,36.348l-1.663,13.528c0,0,6.976-19.657,13.356-14.493 c6.38,5.163-15.548,18.059-18.038,46.872L205.77,342.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M207.145,344.529c0,0-2.725-39.834,13.489-58.805c16.214-18.971-12.293-2.057-17.693,17.142 c0,0-0.157-35.774,16.106-58.531c16.263-22.758-10.976-6.117-16.208,19.028c0,0-0.2-31.925,8.041-48.634 c8.241-16.71-3.722-6.947-9.143,3.49c-5.421,10.437-3.447,38.549-3.447,38.549s-4.394-52.091-14.928-49.549 c-10.534,2.542,10.444,39.339,11.802,57.073c0,0-8.989-24.921-18.563-21.419c-9.574,3.502,13.021,9.274,19.255,45.376l1.69,16.746 c0,0-8.081-24.478-16.092-18.312c-8.01,6.167,18.701,22.781,21.002,58.414L207.145,344.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M232.344,364.391c0,10.93-11.85,19.8-26.47,19.8c-14.63,0-26.48-8.87-26.48-19.8 c0-4.93,2.4-9.42,6.38-12.88l-3.13-13.25h46.45l-3.13,13.25C229.944,354.971,232.344,359.461,232.344,364.391z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M246.394,86.281c-14.543,16.155-21.744,38.146-20.515,59.848 c1.229,21.702,9.23,42.476,18.966,61.91c8.526,17.019,18.718,36.319,11.738,54.028c-3.903,9.902-12.787,17.233-22.617,21.312 c-9.83,4.079-20.606,5.262-31.236,5.793c-18.117,0.907-36.51,0.076-54.144,4.329c-17.634,4.253-34.988,14.747-41.805,31.557 c-8.032,19.806,1.085,43.511,17.174,57.581c16.089,14.07,37.674,20.114,58.838,23.097c29.659,4.181,60.048,3.134,89.349-3.079 c23.526-4.988,46.684-13.476,65.878-27.966c19.194-14.49,34.171-35.452,38.276-59.148c4.105-23.696-3.862-49.908-22.642-64.931 c-7.812-6.249-17.227-10.524-24.08-17.813c-6.852-7.289-10.33-19.434-3.967-27.154c4.204-5.1,11.276-6.663,17.84-7.446 c32.271-3.85,68.021,2.801,95.009-15.307c15.455-10.369,25.45-28.046,27.651-46.526c2.201-18.48-1.788-38.481-13.434-52.998 C420.954,43.832,285.249,43.119,246.394,86.281z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M246.394,86.281c-14.543,16.155-21.744,38.146-20.515,59.848 c1.229,21.702,9.23,42.476,18.966,61.91c8.526,17.019,18.718,36.319,11.738,54.028c-3.903,9.902-12.787,17.233-22.617,21.312 c-9.83,4.079-20.606,5.262-31.236,5.793c-18.117,0.907-36.51,0.076-54.144,4.329c-17.634,4.253-34.988,14.747-41.805,31.557 c-8.032,19.806,1.085,43.511,17.174,57.581c16.089,14.07,37.674,20.114,58.838,23.097c29.659,4.181,60.048,3.134,89.349-3.079 c23.526-4.988,46.684-13.476,65.878-27.966c19.194-14.49,34.171-35.452,38.276-59.148c4.105-23.696-3.862-49.908-22.642-64.931 c-7.812-6.249-17.227-10.524-24.08-17.813c-6.852-7.289-10.33-19.434-3.967-27.154c4.204-5.1,11.276-6.663,17.84-7.446 c32.271-3.85,68.021,2.801,95.009-15.307c15.455-10.369,25.45-28.046,27.651-46.526c2.201-18.48-1.788-38.481-13.434-52.998 C420.954,43.832,285.249,43.119,246.394,86.281z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 415.693,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "234.073,257.003 236.566,242.581 241.482,244.003  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "235.717,261.616 249.779,257.554 247.826,252.824  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "238.224,256.194 246.231,241.048 251.625,244.796  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M105.889,278.912h-6.333c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h6.333 c0.276,0,0.5,0.224,0.5,0.5S106.165,278.912,105.889,278.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M95.346,278.912H63.624c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h31.722 c0.276,0,0.5,0.224,0.5,0.5S95.622,278.912,95.346,278.912z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M207.853,336.778c-0.121,0-0.243-0.044-0.339-0.132c-0.203-0.188-0.216-0.504-0.029-0.707 l2.965-3.221c0.187-0.202,0.504-0.214,0.706-0.029c0.203,0.188,0.216,0.504,0.029,0.707l-2.965,3.221 C208.123,336.724,207.988,336.778,207.853,336.778z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M180.743,362.407c-0.183,0-0.358-0.101-0.446-0.274c-0.125-0.246-0.026-0.547,0.22-0.672 c9.267-4.693,23.953-22.229,24.101-22.406c0.176-0.211,0.491-0.241,0.704-0.063c0.212,0.177,0.241,0.492,0.063,0.704 c-0.606,0.728-14.967,17.871-24.416,22.658C180.896,362.39,180.819,362.407,180.743,362.407z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CB7A63"
    },
    points: "252.705,356.93 259.837,351.021 241.863,333.961 234.19,340.507  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M265.624,348.742c-0.485-0.296-1.46-0.156-2.473,0.122c-0.482,0.137-0.976,0.302-1.421,0.464 c-0.348,0.126-0.673,0.257-0.94,0.369c-0.399,0.171-0.693,0.301-0.792,0.349c-0.095,0.024-0.154,0.115-0.16,0.21 c-0.007,0.035,0.01,0.074,0.029,0.102c0.033,0.048,0.08,0.087,0.142,0.105c1.012,0.269,2.048,0.441,3.095,0.524 c0.515,0.073,1.039,0.028,1.529-0.114c0.025-0.007,0.051-0.015,0.069-0.017c0.281-0.091,0.555-0.207,0.813-0.363 c0.333-0.268,0.513-0.684,0.474-1.112C265.984,349.122,265.85,348.881,265.624,348.742z M265.525,349.396 c0.047,0.291-0.079,0.579-0.316,0.751c-0.186,0.157-0.458,0.262-0.807,0.328c-0.337,0.069-0.749,0.087-1.219,0.064 c-0.549-0.02-1.193-0.105-1.9-0.239c-0.151-0.029-0.313-0.059-0.469-0.094c0.852-0.41,1.744-0.715,2.661-0.927 c0.49-0.112,0.979-0.193,1.481-0.243c0.15-0.002,0.294,0.032,0.425,0.104C265.471,349.2,265.526,349.294,265.525,349.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M262.353,344.984c-0.464,0.074-0.876,0.345-1.135,0.734c-0.082,0.117-0.148,0.242-0.204,0.382 c-0.597,1.286-0.287,3.236-0.223,3.596c0.007,0.025,0.01,0.044,0.014,0.051c0.015,0.081,0.069,0.145,0.148,0.172 c0.044,0.02,0.09,0.029,0.141,0.015c0.03,0,0.058-0.019,0.087-0.05c0.17-0.136,0.35-0.33,0.549-0.557 c0.286-0.336,0.587-0.754,0.85-1.196c0.616-1.006,1.06-2.148,0.787-2.739C263.259,345.143,262.997,344.878,262.353,344.984z  M262.949,345.577c0.173,0.387-0.164,1.284-0.666,2.162c-0.327,0.557-0.713,1.103-1.088,1.5 c-0.078-0.633-0.159-1.831,0.147-2.716c0.063-0.204,0.151-0.386,0.258-0.54c0.166-0.245,0.412-0.433,0.691-0.512l0.136-0.022 C262.85,345.372,262.928,345.531,262.949,345.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M258.914,350.597l-8.959,4.521c-0.355,0.166-0.535,0.567-0.422,0.942l2.641,8.384 c0.291,0.822,1.193,1.252,2.015,0.961c0.053-0.019,0.105-0.041,0.156-0.065c15.347-5.395,20.054-9.208,21.655-10.081 c4.567-2.492,2.003-5.732,0.297-5.328c-7.655,1.833-10.223,1.358-13.535,0.505C261.01,350.16,259.453,350.33,258.914,350.597z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "241.865,333.969 250.966,342.038 243.293,348.584  234.191,340.515  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "239.033,348.523 250.483,337.965 247.963,333.538 234.72,344.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "239.033,348.523 250.483,337.965 247.963,333.538 234.72,344.909  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M246.157,335.091l-1.534,1.319l-2.293,1.969l-1.367,1.165l-3.992,3.431l-0.766,0.654 c0,0-16.315-9.191-25.39-17.037c-6.219-5.377-6.776-7.378-7.435-6.878c-8.771,6.672-34.733,29.732-49.445,41.73 c-0.478,0.054-0.954,0.096-1.436,0.131c-7.86,0.576-14.044-0.286-18.838-2.115c-0.05-6.38,5.41-21.278,5.862-22.718 c0,0,21.71-21.577,56.883-39.816c0.346-0.179,0.709-0.322,1.062-0.472c0.458-0.202,0.915-0.392,1.378-0.557 c1.837-0.698,3.642-1.132,5.393-1.215c1.571-0.082,3.096,0.2,4.572,0.719c0.834,0.29,1.648,0.653,2.439,1.073 c0.696,0.354,1.376,0.758,2.04,1.184c1.088,0.692,2.138,1.46,3.135,2.225c2.243,1.732,19.232,23.625,28.367,33.725 c0.005,0.007,0.005,0.007,0.005,0.007C245.274,334.138,245.726,334.638,246.157,335.091z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M246.157,335.091l-1.534,1.319l-2.293,1.969l-1.367,1.165l-3.992,3.431l-0.766,0.654 c0,0-16.315-9.191-25.39-17.037c-6.219-5.377-6.776-7.378-7.435-6.878c-8.771,6.672-34.733,29.732-49.445,41.73 c-0.478,0.054-0.954,0.096-1.436,0.131c-7.86,0.576-14.044-0.286-18.838-2.115c-0.05-6.38,5.41-21.278,5.862-22.718 c0,0,21.71-21.577,56.883-39.816c0.346-0.179,0.709-0.322,1.062-0.472c0.458-0.202,0.915-0.392,1.378-0.557 c1.837-0.698,3.642-1.132,5.393-1.215c1.571-0.082,3.096,0.2,4.572,0.719c0.834,0.29,1.648,0.653,2.439,1.073 c0.696,0.354,1.376,0.758,2.04,1.184c1.088,0.692,2.138,1.46,3.135,2.225c2.243,1.732,19.232,23.625,28.367,33.725 c0.005,0.007,0.005,0.007,0.005,0.007C245.274,334.138,245.726,334.638,246.157,335.091z"
  })))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M130.315,242.965c1.372,6.228,2.814,15.316-1.462,19.594c5.305,9.338,11.674,18.029,18.98,25.9 c9.369-16.289,0.485-26.357,0.485-26.357c-7.023-1.503-6.909-4.333-5.808-9.208L130.315,242.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M124.51,263.35c0.519-1.687,1.59-3.151,3.041-4.156c1.405-1.076,15.961-1.237,19.745,0.003 c2.212,0.7,4.092,2.183,5.289,4.171L124.51,263.35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M191.677,288.147l3.766-1.717l0.186,6.141c0,0-1.762,1.573-3.688,2.167 c-1.848,0.57-3.606-1.13-3.151-3.01l0,0C189.166,290.165,190.227,288.848,191.677,288.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M200.258,288.164l-0.197,2.251c-0.055,0.695-0.558,1.277-1.239,1.43l-3.223,0.724l-0.186-6.141 l3.271,0.048c0.868-0.012,1.575,0.683,1.579,1.552C200.264,288.073,200.262,288.119,200.258,288.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M143.875,305.615c5.665,2.791,12.598,4.392,19.406,3.244 c8.021-1.353,21.995-9.397,28.07-14.016l-2.047-3.055c-3.035,0.648-27.793,13.232-43.785,1.849 c-2.98-2.121-14.684-10.852-18.82-10.666c-6.706,0.303-6.128,7.332-3.246,10.255 C126.826,296.648,139.243,303.332,143.875,305.615z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.063,290.415c-0.058,0.692-0.556,1.281-1.238,1.427l-3.196,0.723l-0.001,0.008c0,0-1.759,1.574-3.684,2.167 c-0.204,0.061-0.395,0.098-0.59,0.102l-0.009,0.007c-6.08,4.621-20.043,12.658-28.059,14.01 c-6.81,1.145-13.747-0.451-19.406-3.247c-4.634-2.281-17.055-8.968-20.43-12.386c-2.877-2.926-3.456-9.951,3.248-10.259 c4.133-0.179,15.837,8.549,18.824,10.672c15.257,10.848,38.476-0.087,43.229-1.689c0.012-0.074,0.023-0.148,0.043-0.221 c0.19-0.781,0.54-1.503,1.042-2.117c0.484-0.608,1.121-1.116,1.843-1.467l3.73-1.704l0.036-0.011l3.245,0.044 c0.863-0.008,1.573,0.686,1.572,1.556c0.002,0.043,0.004,0.085-0.004,0.135L200.063,290.415z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "195.443,286.431 195.407,286.442 195.41,286.426  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M164.838,273.402c8.495,18.709-11.199,24.055-2.178,54.733l-42.803,1.029 c0.287-16.443,6.131-12.909-1.573-43.823c-0.652-2.618-1.737-10.129,1.053-16.969c1.086-2.661,3.024-4.922,5.553-6.288 c3.161-1.708,17.08-0.374,23.433,0.053C155.2,261.163,163.584,271.061,164.838,273.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M164.838,273.402c8.495,18.709-11.199,24.055-2.178,54.733l-42.803,1.029 c0.287-16.443,6.131-12.909-1.573-43.823c-0.652-2.618-1.737-10.129,1.053-16.969c1.086-2.661,3.024-4.922,5.553-6.288 c3.161-1.708,17.08-0.374,23.433,0.053C155.2,261.163,163.584,271.061,164.838,273.402z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.66,236.28c-0.124,0.82,0.213,1.486,0.724,1.558c0.511,0.072,1.025-0.498,1.143-1.286 c0.118-0.788-0.213-1.486-0.725-1.558C157.292,234.922,156.775,235.499,156.66,236.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.57,235.004l1.964-0.272C159.533,234.732,158.348,236.068,157.57,235.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A02724"
    },
    d: "M156.793,237.361c0,0,0.838,3.576,2.08,5.411c-1.181,0.819-2.883,0.117-2.883,0.117 L156.793,237.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M159.493,230.779c0.154-0.061,0.264-0.198,0.29-0.362c0.035-0.255-0.139-0.492-0.393-0.534 c-1.482-0.259-2.998,0.218-4.064,1.28c-0.189,0.175-0.201,0.471-0.026,0.661c0.175,0.19,0.471,0.201,0.661,0.026 c0.022-0.021,0.042-0.043,0.06-0.068c0.858-0.822,2.058-1.184,3.227-0.972C159.331,230.824,159.416,230.813,159.493,230.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M130.756,229.804c-0.805,9.746-1.361,13.853,2.795,19.522c6.258,8.528,18.425,7.407,22.113-1.909 c3.342-8.384,4.106-22.914-4.787-28.131c-6.338-3.762-14.525-1.674-18.287,4.664 C131.533,225.732,130.904,227.736,130.756,229.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M155.891,246.826c-0.735-0.623-1.299-1.444-1.618-2.383c-0.027-0.104,0.032-0.214,0.139-0.249 c0.104-0.027,0.214,0.032,0.241,0.136c0.295,0.809,0.772,1.518,1.385,2.087L155.891,246.826z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M123.814,217.125c-3.715,5.037-5.406,6.348-0.807,19.757c1.849,5.391,7.22,12.526,9.83,13.181 c4.679,1.176,9.233-2.108,12.746-5.416c3.076-2.896,6.027-6.035,7.9-9.821c1.873-3.786,2.562-8.334,1.015-12.264 c-1.681-4.271-7.607-8.083-12.046-9.018C137.23,212.445,126.903,212.937,123.814,217.125z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M152.967,235.662c0,0,1.169,2.014-0.308,3.512l0.03-2.675L152.967,235.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M152.95,235.659c0,0,0.432,3.084-2.152,4.234l1.385-3.325L152.95,235.659z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M135.776,248.93c0,0-2.837,1.285-2.426,4.084l2.068-2.95L135.776,248.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M135.893,248.986c0,0-2.16,2.244-0.741,4.692l0.829-3.506L135.893,248.986z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.862,231.634c1.013-1.044,2.036-2.101,2.782-3.35c0.746-1.249,1.203-2.727,0.977-4.164 c-0.291-1.858-1.687-3.395-3.321-4.326c-1.634-0.931-3.502-1.351-5.338-1.759c-0.903-0.201-1.909-0.387-2.702,0.088 c-0.766,0.458-1.098,1.427-1.054,2.318c0.045,0.891,0.398,1.733,0.722,2.564c1.27,3.251,2.066,6.585,2.683,10.011 c0.311,1.727,0.074,2.873,1.776,2.207C154.535,234.774,155.987,232.536,156.862,231.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M143.401,236.45c-0.105,2.256,0.691,4.461,2.212,6.13c2.033,2.205,4.613,0.764,5.354-1.979 c0.676-2.458,0.419-6.568-2.245-7.754S143.545,233.702,143.401,236.45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CB7A63"
    },
    points: "256.818,361.424 264.544,353.896 249.595,335.11 240.263,340.618  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M272.425,351.581c-0.859-0.298-2.618,0.659-3.951,1.507c-0.339,0.215-0.644,0.421-0.899,0.599 l-0.022,0.012c-0.047,0.035-0.094,0.071-0.134,0.102c-0.301,0.213-0.519,0.371-0.599,0.434 c-0.095,0.052-0.143,0.155-0.117,0.255c0.026,0.1,0.115,0.175,0.224,0.182c0.917,0.039,1.841,0.006,2.76-0.09 c0.208-0.019,0.405-0.042,0.61-0.069c0.666-0.052,1.308-0.272,1.857-0.641c0.197-0.127,0.385-0.269,0.555-0.429 c0.292-0.351,0.389-0.833,0.252-1.272C272.889,351.906,272.69,351.682,272.425,351.581z M272.475,352.296 c0.105,0.295,0.047,0.622-0.164,0.862c-0.26,0.324-0.784,0.583-1.516,0.758c-0.569,0.142-1.26,0.236-2.065,0.279 c-0.317,0.013-0.66,0.03-1.015,0.025c0.112-0.09,0.221-0.169,0.337-0.252c0.08-0.063,0.156-0.114,0.24-0.17 c1.072-0.752,2.251-1.343,3.505-1.747c0.148-0.043,0.312-0.038,0.471,0.008C272.374,352.094,272.452,352.184,272.475,352.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M268.135,348.388c-0.471,0.183-0.837,0.556-1.02,1.018c-0.631,1.537,0.303,3.909,0.459,4.28 c-0.003,0.011-0.003,0.011,0.008,0.015c0.001,0.019,0.005,0.026,0.009,0.033c0.037,0.085,0.114,0.137,0.196,0.149 c0.053,0.009,0.105,0,0.153-0.017c0.033-0.009,0.066-0.036,0.08-0.063c0.011-0.015,0.018-0.019,0.029-0.035 c0.138-0.181,0.286-0.415,0.425-0.681c0.741-1.388,1.426-3.708,0.824-4.51C269.12,348.342,268.79,348.124,268.135,348.388z  M267.888,353.114c-0.274-0.792-0.747-2.465-0.314-3.513c0.116-0.292,0.33-0.543,0.612-0.689l0.136-0.065 c0.43-0.17,0.541-0.021,0.576,0.026C269.335,349.461,268.667,351.829,267.888,353.114z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "248.813,333.961 255.845,342.964 246.326,348.267  239.185,339.498  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.473,325.895l-0.986,3.881c-0.146,0.307,0.221,0.598,0.709,0.586l44.076-1.044 c0.386-0.015,0.699-0.21,0.718-0.455l-1.103-4.07c0.03-0.261-0.32-0.481-0.74-0.47l-41.97,1.234 C119.9,325.538,119.632,325.666,119.473,325.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M158.686,329.784l-1.157,0.122c-0.229-0.006-0.422-0.07-0.419-0.215l-0.021-5.014 c0.004-0.144,0.186-0.283,0.415-0.311l1.157-0.131c0.229,0.006,0.422,0.07,0.418,0.223l0.021,5.006 C159.098,329.616,158.916,329.756,158.686,329.784z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M142.912,329.987l-1.157,0.122c-0.229-0.006-0.414-0.07-0.418-0.215l-0.013-5.014 c0.004-0.144,0.186-0.284,0.415-0.311l1.149-0.131c0.229,0.006,0.422,0.07,0.418,0.223l0.021,5.006 C143.331,329.837,143.142,329.959,142.912,329.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M142.912,329.987l-1.157,0.122c-0.229-0.006-0.414-0.07-0.418-0.215l-0.013-5.014 c0.004-0.144,0.186-0.284,0.415-0.311l1.149-0.131c0.229,0.006,0.422,0.07,0.418,0.223l0.021,5.006 C143.331,329.837,143.142,329.959,142.912,329.987z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M254.721,337.989l-1.952,1.101l-0.008,0.008l-3.354,1.894l-3.012,1.685l-0.009,0.008 l-3.087,1.744v0.008l-1.185,0.667c0,0-0.267-0.192-0.743-0.542c-0.184-0.125-0.392-0.275-0.634-0.459 c-0.734-0.551-1.76-1.318-2.954-2.269c0,0,0,0,0-0.008c-6.216-4.914-17.288-14.577-20.584-23.362 c-2.128,2.536-4.681,5.724-7.601,9.245c-12.574,15.169-32.115,36.579-55.611,39.366c-0.476,0.067-0.951,0.109-1.435,0.15 c-7.851,0.676-14.042-0.108-18.857-1.877c-12.19-4.464-15.586-15.177-14.752-24.289v-0.033 c0.075-4.264,0.909-11.865,0.909-11.865l44.472,0.05c6.266-7.609,18.84-19.533,31.698-27.05c0.3-0.192,0.609-0.367,0.918-0.534 c0.384-0.225,0.768-0.434,1.151-0.642c4.18-2.286,8.36-4.063,12.324-5.023c0.884-0.209,1.752-0.392,2.611-0.517 c0.901-0.142,1.786-0.217,2.662-0.259v0.008c6.091-0.275,11.381,1.986,14.969,8.068l23.396,33.759L254.721,337.989z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Monitor_Screen_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PC_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "230.724,291.777 181.577,293.807 183.016,262.54 232.162,260.509  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230.148,294.243l-48.43,2.001c-1.374,0.057-2.436-1.015-2.373-2.394l1.43-31.073 c0.063-1.379,1.229-2.543,2.602-2.599l48.43-2.001c1.374-0.057,2.436,1.015,2.373,2.394l-1.429,31.073 C232.688,293.023,231.522,294.187,230.148,294.243z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "230.724,291.777 181.577,293.807 183.016,262.54 232.162,260.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    points: "230.724,291.777 181.577,293.807 183.016,262.54 232.162,260.509  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "200.458,259.49 192.341,295.791  195.571,295.657 203.581,259.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "205.441,259.284 197.325,295.585  203.73,295.32 211.74,259.024  "
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M214.772,294.633l16.355-0.46c0.282,1.898-0.529,2.612-1.571,2.638l-5.231,0.133l-3.495,0.076 l-5.429,0.154l-33.69,0.984l-0.268-2.372L214.772,294.633z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M214.772,294.633l16.355-0.46c0.282,1.898-0.529,2.612-1.571,2.638l-5.231,0.133l-3.495,0.076 l-5.429,0.154l-41.704,1.279c-0.478,0.015-0.92-0.254-1.126-0.686l0,0c-0.374-0.785,0.179-1.695,1.048-1.725L214.772,294.633 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M214.772,294.633l16.355-0.46c0.282,1.898-0.529,2.612-1.571,2.638l-5.231,0.133l-3.495,0.076 l-5.429,0.154l-41.704,1.279c-0.478,0.015-0.92-0.254-1.126-0.686l0,0c-0.374-0.785,0.179-1.695,1.048-1.725L214.772,294.633 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M231.128,294.173l0.098,0.661c0.152,1.023-0.627,1.951-1.669,1.977l-5.231,0.133l-9.711,0.348 l0.157-2.658L231.128,294.173z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M146.393,274.315c0,0-2.314,4.711,4.36,17.152l2.791,5.073l0,0c0.92,1.673,7.035-1.736,8.86-4.874 l0,0C162.403,291.666,150.705,284.65,146.393,274.315z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M202.96,288.818l4.654-1.37l-0.747,7.186c0,0-6.487,4.339-8.735,0.191l0.904-2.317 C199.719,290.748,201.161,289.392,202.96,288.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M212.95,290.274l-0.583,2.59c-0.173,0.801-0.85,1.394-1.667,1.459l-3.867,0.304l0.747-7.185 l3.802,0.603c1.012,0.132,1.727,1.059,1.595,2.072C212.97,290.169,212.961,290.222,212.95,290.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB7A63"
    },
    d: "M164.243,300.973c3.243,4.398,7.803,8.073,13.167,9.122c6.318,1.236,18.476-7.703,24.185-13.488 c-0.288-2.442-0.124-3.76-2.559-4.1c0,0-6.274,4.6-18.11,7.36c-3.822,0.892-6.372-3.018-9.707-8.706 c-1.663-2.836-7.043-14.475-9.069-17.064c-3.255-4.161-12.521-1.176-8.843,8.83 C154.855,287.138,161.591,297.376,164.243,300.973z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M160.777,267.288c6.578,6.038,9.776,16.719,9.776,16.719l-15.355,9.36 c0,0-11.233-15.755-9.225-21.246c1.581-4.265,4.51-7.056,8.357-7.297C156.715,264.674,159.016,265.671,160.777,267.288z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M125.563,330.594l-1.164,0.028c-0.228-0.026-0.414-0.108-0.397-0.259l0.423-4.988 c0.018-0.152,0.211-0.274,0.442-0.282l1.164-0.028c0.227,0.026,0.413,0.116,0.397,0.259l-0.424,4.996 C125.987,330.472,125.791,330.62,125.563,330.594z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "240.227,347.232 255.194,339.751 253.914,334.429 236.854,342.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "240.227,347.232 255.194,339.751 253.914,334.429 236.854,342.215  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M263.943,353.076l-10.318,3.126c-0.406,0.11-0.671,0.501-0.621,0.919l1.243,9.362 c0.156,0.924,1.031,1.546,1.955,1.39c0.06-0.01,0.119-0.023,0.177-0.04c17.24-2.869,22.927-6.033,24.783-6.661 c5.295-1.792,3.18-5.695,1.3-5.584c-8.44,0.523-11.071-0.455-14.417-1.971C266.242,353.001,264.562,352.893,263.943,353.076z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M125.172,229.691c-3.098,0.488-6.17-1.89-7.14-4.873c-0.97-2.983-0.167-6.314,1.423-9.017 c1.175-1.996,8.842-6.742,11.686-1.402C136.801,225.023,125.172,229.691,125.172,229.691z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "230.284,271.228 200.034,272.514 200.168,269.514 230.418,268.227  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "230.284,271.228 200.034,272.514 200.168,269.514 230.418,268.227  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "230.098,275.393 199.848,276.68 199.982,273.679 230.232,272.392  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "230.098,275.393 199.848,276.68 199.982,273.679 230.232,272.392  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "229.911,279.558 199.661,280.845 199.796,277.845 230.045,276.558  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "229.911,279.558 199.661,280.845 199.796,277.845 230.045,276.558  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "229.724,283.724 199.475,285.011 199.609,282.01 229.859,280.723  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "229.724,283.724 199.475,285.011 199.609,282.01 229.859,280.723  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "229.538,287.889 199.288,289.176 199.422,286.175 229.672,284.888  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "229.538,287.889 199.288,289.176 199.422,286.175 229.672,284.888  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.401,
    y: 274.251,
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -11.6311 8.2707)",
    style: {
      fill: "#407BFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.401,
    y: 274.251,
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -11.6311 8.2707)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.286,
    y: 277.136,
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -11.7552 8.2684)",
    style: {
      fill: "#407BFF"
    },
    width: 2.429,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.286,
    y: 277.136,
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -11.7552 8.2684)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2.429,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.172,
    y: 280.021,
    transform: "matrix(0.9991 -0.0429 0.0429 0.9991 -11.852 8.2464)",
    style: {
      fill: "#407BFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.172,
    y: 280.021,
    transform: "matrix(0.9991 -0.0429 0.0429 0.9991 -11.852 8.2464)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.058,
    y: 282.906,
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -12.0032 8.264)",
    style: {
      fill: "#407BFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.058,
    y: 282.906,
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -12.0032 8.264)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.944,
    y: 285.79,
    transform: "matrix(0.9991 -0.0429 0.0429 0.9991 -12.0995 8.2419)",
    style: {
      fill: "#407BFF"
    },
    width: 2.428,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "184.966,286.843 185.058,285.837 187.483,285.733 187.392,286.739  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.829,
    y: 288.676,
    transform: "matrix(0.9991 -0.0421 0.0421 0.9991 -11.9989 8.0814)",
    style: {
      fill: "#407BFF"
    },
    width: 2.429,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.829,
    y: 288.676,
    transform: "matrix(0.9991 -0.0421 0.0421 0.9991 -11.9989 8.0814)",
    style: {
      fill: "#FFFFFF"
    },
    width: 2.429,
    height: 1.001
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "190.337,271.439 185.319,273.305 185.374,271.987 188.152,271.539 185.4,271.347  185.454,270.029  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "220.994,266.668 200.034,267.56 200.127,265.481 221.087,264.589  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "220.994,266.668 200.034,267.56 200.127,265.481 221.087,264.589  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "192.714,267.743 189.641,267.881 190.883,267.09 191.223,267.403 191.591,267.081  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "190.758,266.994 189.516,267.785 189.608,265.955  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "192.907,265.896 192.806,267.635 191.684,266.973  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 191.178,
    y: 266.701,
    transform: "matrix(0.6871 -0.7266 0.7266 0.6871 -133.9454 222.3975)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.099,
    height: 0.013
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 191.231,
    y: 266.658,
    transform: "matrix(0.726 -0.6877 0.6877 0.726 -131.0187 204.6127)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.013,
    height: 0.099
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "192.907,265.724 191.591,266.923 191.223,267.245 190.883,266.933 189.733,265.893  189.641,265.81  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.401,
    y: 266.107,
    transform: "matrix(0.9991 -0.0425 0.0425 0.9991 -11.1383 8.1648)",
    style: {
      fill: "#407BFF"
    },
    width: 2.429,
    height: 0.299
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.401,
    y: 266.872,
    transform: "matrix(0.9991 -0.0425 0.0425 0.9991 -11.1671 8.1627)",
    style: {
      fill: "#407BFF"
    },
    width: 2.429,
    height: 0.299
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.401,
    y: 267.637,
    transform: "matrix(0.9991 -0.0425 0.0425 0.9991 -11.2032 8.1662)",
    style: {
      fill: "#407BFF"
    },
    width: 2.429,
    height: 0.299
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Files"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M328.705,115.677h-14.566c-1.321,0-2.392-1.071-2.392-2.392c0-1.321,1.071-2.392,2.392-2.392 h14.566c1.321,0,2.392,1.071,2.392,2.392C331.097,114.606,330.026,115.677,328.705,115.677z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.705,115.677h-14.566c-1.321,0-2.392-1.071-2.392-2.392c0-1.321,1.071-2.392,2.392-2.392 h14.566c1.321,0,2.392,1.071,2.392,2.392C331.097,114.606,330.026,115.677,328.705,115.677z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M382.158,164.788l-55.855,102.798c-0.719,1.324-2.375,1.814-3.699,1.095l-95.054-51.647 c-1.324-0.719-1.814-2.375-1.094-3.699l72.651-133.71c0.719-1.324,2.375-1.814,3.699-1.094l64.046,34.799L382.158,164.788z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M382.158,164.788l-55.855,102.798c-0.719,1.324-2.375,1.814-3.699,1.095l-95.054-51.647 c-1.324-0.719-1.814-2.375-1.094-3.699l72.651-133.71c0.719-1.324,2.375-1.814,3.699-1.094l64.046,34.799L382.158,164.788z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 273.811,
    y: 168.408,
    transform: "matrix(0.8801 0.4748 -0.4748 0.8801 118.811 -128.6575)",
    style: {
      fill: "#407BFF"
    },
    width: 80.657,
    height: 5.002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.11,
    y: 186.39,
    transform: "matrix(0.8801 0.4748 -0.4748 0.8801 126.1852 -121.8956)",
    style: {
      fill: "#407BFF"
    },
    width: 80.657,
    height: 5.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.409,
    y: 204.372,
    transform: "matrix(0.8801 0.4748 -0.4748 0.8801 133.5605 -115.1341)",
    style: {
      fill: "#407BFF"
    },
    width: 80.657,
    height: 5.003
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M366.944,113.285l-16.848,31.007c-0.719,1.324-0.229,2.98,1.094,3.699l30.912,16.796 L366.944,113.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M366.944,113.285l-16.848,31.007c-0.719,1.324-0.229,2.98,1.094,3.699 l30.912,16.796L366.944,113.285z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M396.724,161.332L340.868,264.13c-0.719,1.324-2.375,1.814-3.699,1.095l-95.054-51.647 c-1.324-0.719-1.814-2.375-1.095-3.699l72.651-133.71c0.719-1.324,2.375-1.814,3.699-1.094l64.046,34.799L396.724,161.332z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M396.724,161.332L340.868,264.13c-0.719,1.324-2.375,1.814-3.699,1.095l-95.054-51.647 c-1.324-0.719-1.814-2.375-1.095-3.699l72.651-133.71c0.719-1.324,2.375-1.814,3.699-1.094l64.046,34.799L396.724,161.332z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M363.491,183.377l-67.198-36.251c-1.046-0.564-2.352-0.174-2.916,0.872l-0.331,0.614 c-0.564,1.046-0.174,2.352,0.872,2.916l67.197,36.251c1.046,0.564,2.352,0.174,2.916-0.872l0.332-0.614 C364.928,185.247,364.537,183.942,363.491,183.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.79,201.359l-67.198-36.251c-1.046-0.564-2.352-0.174-2.916,0.872l-0.331,0.614 c-0.565,1.046-0.174,2.352,0.872,2.916l67.198,36.251c1.046,0.564,2.352,0.174,2.916-0.872l0.331-0.614 C355.227,203.229,354.837,201.924,353.79,201.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M344.09,219.341l-67.198-36.251c-1.046-0.564-2.352-0.174-2.916,0.872l-0.331,0.614 c-0.564,1.046-0.174,2.352,0.872,2.916l67.198,36.251c1.046,0.564,2.352,0.174,2.916-0.872l0.331-0.614 C345.526,221.211,345.136,219.906,344.09,219.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M381.51,109.829l-16.848,31.007c-0.719,1.324-0.229,2.98,1.095,3.699l30.912,16.796 L381.51,109.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M381.51,109.829l-16.848,31.007c-0.719,1.324-0.229,2.98,1.095,3.699 l30.912,16.796L381.51,109.829z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M377.652,62.696l4.696,20.869c-17.802,4.889-33.768,22.504-45.263,39.149 c-4.535,6.567-8.372,14.205-11.241,22.272c0,0,35.894-32.465,55.681-34.37l-0.941,34.498c0,0,20.521-39.974,60.377-54.604 C440.962,90.51,407.577,66.471,377.652,62.696z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Couch"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M135.514,290.703l9.07,103.673h-14.617l-9.76-111.562h6.698 C131.386,282.814,135.124,286.239,135.514,290.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M135.596,291.639l8.988,102.737h-14.617l-9.76-111.562h5.759 C130.978,282.814,135.159,286.645,135.596,291.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M126.012,289.568l9.17,104.808H48.144l-9.057-103.518c-0.378-4.324,3.03-8.044,7.371-8.044 h72.184C122.478,282.814,125.678,285.746,126.012,289.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M126.112,290.708l9.07,103.668H48.144l-8.938-102.161 c-0.442-5.054,3.541-9.401,8.615-9.401h69.677C121.981,282.814,125.721,286.241,126.112,290.708z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M279.192,394.377H48.541l-2.515-28.747h221.406c5.106,0,9.608,4.139,10.054,9.245 L279.192,394.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M279.192,394.377H48.541l-2.515-28.747h221.406c5.106,0,9.608,4.139,10.054,9.245 L279.192,394.377z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M289.767,405.385H45.83c-3.164,0-5.729-2.565-5.729-5.729l0,0c0-3.164,2.565-5.729,5.729-5.729 h243.936c3.164,0,5.729,2.565,5.729,5.729l0,0C295.495,402.821,292.931,405.385,289.767,405.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M289.767,405.385H148.158c-3.164,0-5.729-2.565-5.729-5.729l0,0c0-3.164,2.565-5.729,5.729-5.729 h141.608c3.164,0,5.729,2.565,5.729,5.729l0,0C295.495,402.821,292.931,405.385,289.767,405.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "49.029,405.385 51.92,415.223 57.702,415.223 60.882,405.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "49.029,405.385 51.92,415.223 57.702,415.223 60.882,405.385  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "131.861,405.385 134.753,415.223 140.535,415.223 143.715,405.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "131.861,405.385 134.753,415.223 140.535,415.223 143.715,405.385  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "195.259,405.385 198.15,415.223 203.932,415.223 207.112,405.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "195.259,405.385 198.15,415.223 203.932,415.223 207.112,405.385  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "278.091,405.385 280.982,415.223 286.764,415.223 289.944,405.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "278.091,405.385 280.982,415.223 286.764,415.223 289.944,405.385  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJob);
export default __webpack_public_path__ + "static/media/Create-job.063654f0.svg";
export { ForwardRef as ReactComponent };